import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { RfqModel } from "@insite/client-framework/Types/ApiModels";
import PreconRfqFormState from "@preconBlueprint/Store/Pages/Rfq/PreconRfqFormState";
import { Draft } from "immer";

const initialState: PreconRfqFormState = {
    firstNameErrorMessage: "",
    companyNameErrorMessage: "",
    jobTitleErrorMessage: "",
    emailErrorMessage: "",
    phoneErrorMessage: "",
    countryErrorMessage: "",
    stateErrorMessage: "",
    addressErrorMessage: "",
    cityErrorMessage: "",
    postalCodeErrorMessage: "",
    quoteDetailsErrorMessage: "",
    manufacturerErrorMessage: "",
    productCategoryErrorMessage: "",
    quantityErrorMessage: "",
    productsOfInterestErrorMessage: ""
};

const reducer = {
    "Pages/Rfq/PreconValidateRfqForm": (
        draft: Draft<PreconRfqFormState>,
        action: {
            isSubscribed?: boolean;
            firstName?: string;
            firstNameErrorMessage?: string;
            companyName?: string;
            companyNameErrorMessage?: string;
            jobTitle?: string;
            jobTitleErrorMessage?: string;
            email?: string;
            emailErrorMessage?: string;
            phone?: string;
            phoneErrorMessage?: string;
            country?: string;
            countryErrorMessage?: string;
            state?: string;
            stateErrorMessage?: string;
            address?: string;
            addressErrorMessage?: string;
            city?: string;
            cityErrorMessage?: string;
            postalCode?: string;
            postalCodeErrorMessage?: string;
            quoteDetails?: string;
            quoteDetailsErrorMessage?: string;
            manufacturer?: string;
            manufacturerErrorMessage?: string;
            productCategory?: string;
            productCategoryErrorMessage?: string;
            quantity?: number;
            quantityErrorMessage?: string;
            productsOfInterest?: string;
            productsOfInterestErrorMessage?: string;
        },
    ) => {

        if (typeof action.isSubscribed !== "undefined") {
            draft.isSubscribed = action.isSubscribed;
        }

        if (typeof action.firstName !== "undefined") {
            draft.firstNameErrorMessage = action.firstNameErrorMessage;
        }

        if (typeof action.companyName !== "undefined") {
            draft.companyNameErrorMessage = action.companyNameErrorMessage;
        }

        if (typeof action.jobTitle !== "undefined") {
            draft.jobTitleErrorMessage = action.jobTitleErrorMessage;
        }

        if (typeof action.email !== "undefined") {
            draft.emailErrorMessage = action.emailErrorMessage;
        }

        if (typeof action.phone !== "undefined") {
            draft.phoneErrorMessage = action.phoneErrorMessage;
        }

        if (typeof action.country !== "undefined") {
            draft.countryErrorMessage = action.countryErrorMessage;
        }

        if (typeof action.state !== "undefined") {
            draft.stateErrorMessage = action.stateErrorMessage;
        }

        if (typeof action.address !== "undefined") {
            draft.addressErrorMessage = action.addressErrorMessage;
        }

        if (typeof action.city !== "undefined") {
            draft.cityErrorMessage = action.cityErrorMessage;
        }

        if (typeof action.postalCode !== "undefined") {
            draft.postalCodeErrorMessage = action.postalCodeErrorMessage;
        }

        if (typeof action.quoteDetails !== "undefined") {
            draft.quoteDetailsErrorMessage = action.quoteDetailsErrorMessage;
        }

        if(typeof action.manufacturer !== "undefined"){
            draft.manufacturerErrorMessage = action.manufacturerErrorMessage
        }

        if (typeof action.productCategory !== "undefined") {
            draft.productCategoryErrorMessage = action.productCategoryErrorMessage;
        }

        if (typeof action.productsOfInterest !== "undefined") {
            draft.productsOfInterestErrorMessage = action.productsOfInterestErrorMessage;
        }

        if (typeof action.quantity !== "undefined") {
            draft.quantityErrorMessage = action.quantityErrorMessage;
        }
    },
    "Pages/Rfq/PreconSetInitialValues": (
        draft: Draft<PreconRfqFormState>,
        action: {
            rfq: RfqModel;
        },
    ) => {
        draft.rfq = {
            ...action.rfq,
        };
        delete draft.firstNameErrorMessage;
        delete draft.companyNameErrorMessage;
        delete draft.jobTitleErrorMessage;
        delete draft.emailErrorMessage;
        delete draft.phoneErrorMessage;
        delete draft.countryErrorMessage;
        delete draft.stateErrorMessage;
        delete draft.addressErrorMessage;
        delete draft.cityErrorMessage;
        delete draft.postalCodeErrorMessage;
        delete draft.quoteDetailsErrorMessage;
        delete draft.manufacturerErrorMessage;
        delete draft.productCategoryErrorMessage;
        delete draft.productsOfInterestErrorMessage;
        delete draft.quantityErrorMessage;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
